<template>
    <a v-if="exists" :href="url" class="d-block w-100 text-center">
        <font-awesome-icon
                :icon="['fal', 'download']"
                size="lg"
        >
        </font-awesome-icon>
    </a>
</template>

<script>
import Vue from 'vue';
import HandIn from '@/services/HandIn/HandIn';

export default Vue.extend({

  computed: {
    exists() {
      return this.params.data.zipExists;
    },
    url() {
      const { reportId } = this.params.data;
      const url = HandIn.downloadZip(reportId);
      return `${url}?token=${this.$store.getters.authToken}`;
    },
  },
});
</script>

<style lang="scss">
.overflow-cell {
    overflow: visible;
}

.ag-row {
    z-index: 0;

    &.ag-row-focus {
        z-index: 1;
    }
}
</style>
